

import classNames from 'classnames';
import { IplayAudio, IparsingAI } from '@/utils/audioPlay';
import { ErrorSvg, CorrectSvg } from '../../Svg';
import Analysis from '../Analysis';
import SpeechBtn from '../SpeechBtn';
import HtmlParser from '../HtmlParser';
import style from './index.module.less';

interface IInput {
  type?: string | null | number;
  className?: string;
  playAudio?: IplayAudio;
  parsingAI?: IparsingAI;
  isListen?: boolean;
  dataKey?: string;
  answerKey?: string;
  numberKey?: string;
  answer?: string;
  numberHtml?: string;
  displayAnswer?: string;
  placeholder: string;
  value?: string;
  id?: string;
  onInput?: (value: React.FormEvent<HTMLInputElement>)=> void;
  onFocus?: () => void;
  hideCorrect?: boolean;
}

export default function Input(props: IInput) {
  const {type, className, onInput, placeholder, id, value, onFocus, hideCorrect = false} = props;
  if (!type) {
    return <input placeholder={placeholder} id={id} onInput={onInput} onFocus={onFocus} value={value} className={classNames(style.myInput, className)} type="text"/>;
  } else {
    const {className, placeholder, numberHtml, numberKey, answerKey, answer, dataKey, displayAnswer = '', playAudio, parsingAI, isListen }= props;
    return (
      <>
        <div className={classNames(style[type], className, style.box)} id={id}>
          <span className={style.number} data-key={numberKey}><HtmlParser htmlString={numberHtml || placeholder}></HtmlParser></span><span data-key={answerKey}><HtmlParser htmlString={answer || value}></HtmlParser></span><i className={style.icon}>{type === 'success' ? CorrectSvg({className: style.svgIcon}) : ErrorSvg({className: style.svgIcon})}</i>
        </div>
        {
          !hideCorrect ? <span className={style.answer} data-key={dataKey}><HtmlParser htmlString={displayAnswer}></HtmlParser></span> : null
        }
        {isListen && !hideCorrect ? <SpeechBtn onClick={playAudio} index={Number(placeholder)}></SpeechBtn> : null}
        {
          !hideCorrect ? <Analysis onClick={parsingAI}></Analysis> : null
        }
      </>
    );
  } 
}